export function imgUrlReplace (topDishData) {
      topDishData.map(item => {
        if(item.top_dish == 'Fried/Deep-fried' && item.market == 'ID' &&item.brand =="Bango"){
          item.top_dish_variant_image_url_lg = item.top_dish_variant_image_url_lg.replace('frieddeep-fried', 'fried')
          item.top_dish_variant_image_url_sm = item.top_dish_variant_image_url_sm.replace('frieddeep-fried', 'fried')
        }
        if(item.top_dish == 'Fried/Deep-fried' && item.market == 'ID' &&item.brand =="Royco"){
          item.top_dish_variant_image_url_lg = item.top_dish_variant_image_url_lg.replace('frieddeep-fried', 'fried-deep-fried')
          item.top_dish_variant_image_url_sm = item.top_dish_variant_image_url_sm.replace('frieddeep-fried', 'fried-deep-fried')
        }
        if(item.top_dish == "Maizena Top Dish" && item.market == 'BR'){
          item.top_dish_variant_image_url_lg = item.top_dish_variant_image_url_lg.replace('maizena/', '')
          item.top_dish_variant_image_url_sm = item.top_dish_variant_image_url_sm.replace('maizena/', '')
        }
        if(item.top_dish_variant_image_url_lg == 'tdti/us/hellmanns/burgers/cheese-burger.png'){
          item.top_dish_variant_image_url_lg = 'tdti/us/hellmanns/burgers/cheeseburger.png'
          item.top_dish_variant_image_url_sm = 'tdti/us/hellmanns/burgers/cheeseburger-thumb.png'
        }
        if(item.top_dish_variant_image_url_lg == "tdti/us/hellmanns/hot-dips/smoked-salmon-dip.png"){
            item.top_dish_variant_image_url_lg = "tdti/us/hellmanns/dips/salmon-dip.png"
            item.top_dish_variant_image_url_sm = "tdti/us/hellmanns/dips/salmon-dip-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/us/hellmanns/hot-dips/spinach-dip.png"){
            item.top_dish_variant_image_url_lg = "tdti/us/hellmanns/dips/spinach-dip.png"
            item.top_dish_variant_image_url_sm = "tdti/us/hellmanns/dips/spinach-dip-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/us/hellmanns/hot-dips/buffalo-chicken-dip.png"){
            item.top_dish_variant_image_url_lg = "tdti/us/hellmanns/dips/buffalo-chicken-dip.png"
            item.top_dish_variant_image_url_sm = "tdti/us/hellmanns/dips/buffalo-chicken-dip-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/us/hellmanns/hot-dips/artichoke-dip.png"){
            item.top_dish_variant_image_url_lg = "tdti/us/hellmanns/dips/artichoke-dip.png"
            item.top_dish_variant_image_url_sm = "tdti/us/hellmanns/dips/artichoke-dip-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/us/hellmanns/hot-dips/cheese-dip.png"){
            item.top_dish_variant_image_url_lg = "tdti/us/hellmanns/dips/cheese-dip.png"
            item.top_dish_variant_image_url_sm = "tdti/us/hellmanns/dips/cheese-dip-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/us/hellmanns/hot-dips/taco-dip.png"){
            item.top_dish_variant_image_url_lg = "tdti/us/hellmanns/dips/taco-dip.png"
            item.top_dish_variant_image_url_sm = "tdti/us/hellmanns/dips/taco-dip-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/us/hellmanns/hot-dips/mexican-dip.png"){
            item.top_dish_variant_image_url_lg = "tdti/us/hellmanns/dips/mexican-dip.png"
            item.top_dish_variant_image_url_sm = "tdti/us/hellmanns/dips/mexican-dip-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/us/hellmanns/cold-dips/aioli.png"){
            item.top_dish_variant_image_url_lg = "tdti/us/hellmanns/dips/aioli.png"
            item.top_dish_variant_image_url_sm = "tdti/us/hellmanns/dips/aioli-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/us/hellmanns/cold-dips/tzatziki.png"){
            item.top_dish_variant_image_url_lg = "tdti/us/hellmanns/dips/tzatziki.png"
            item.top_dish_variant_image_url_sm = "tdti/us/hellmanns/dips/tzatziki-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/us/hellmanns/bound-salads/cabbage-salad.png"){
            item.top_dish_variant_image_url_lg = "tdti/us/hellmanns/bound-salads/cabbage-salad.png"
            item.top_dish_variant_image_url_sm = "tdti/us/hellmanns/bound-salads/cabbage-salad-1-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/us/hellmanns/fries/tater-tots.png"){
            item.top_dish_variant_image_url_lg = "tdti/us/hellmanns/fries/tator-tots.png"
            item.top_dish_variant_image_url_sm = "tdti/us/hellmanns/fries/tator-tots-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/us/hellmanns/cold-dips/onion-dip.png"){
            item.top_dish_variant_image_url_lg = "tdti/us/hellmanns/dips/onion-dip.png"
            item.top_dish_variant_image_url_sm = "tdti/us/hellmanns/dips/onion-dip-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/us/knorr/burgers/cheese-burger.png"){
            item.top_dish_variant_image_url_lg = "tdti/us/knorr/burgers/cheeseburger.png"
            item.top_dish_variant_image_url_sm = "tdti/us/knorr/burgers/cheeseburger-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/us/knorr/bowls/bibimbap.png"){
            item.top_dish_variant_image_url_lg = "tdti/us/knorr/bowls/chicken-cheddar-brocolli-bowl.png"
            item.top_dish_variant_image_url_sm = "tdti/us/knorr/bowls/chicken-cheddar-brocolli-bowl-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/us/knorr/bowls/yakitori.png"){
            item.top_dish_variant_image_url_lg = "tdti/us/knorr/bowls/teriyaki-bowl.png"
            item.top_dish_variant_image_url_sm = "tdti/us/knorr/bowls/teriyaki-bowl-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/in/knorr/rice/fried-rice.png"){
            item.top_dish_variant_image_url_lg = "tdti/in/knorr/rice/indian-fried-rice.png"
            item.top_dish_variant_image_url_sm = "tdti/in/knorr/rice/indian-fried-rice-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/in/knorr/soup/broccoli-soup.png"){
            item.top_dish_variant_image_url_lg = "tdti/in/knorr/soup/brocolli-soup.png"
            item.top_dish_variant_image_url_sm = "tdti/in/knorr/soup/brocolli-soup-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/id/bango/stir-fried/cumi-masak-bumbu.png"){
            item.top_dish_variant_image_url_lg = "tdti/id/bango/stir-fried/cumi-masak-bumbu-(asam-manis,cabe-ijo,dll).png"
            item.top_dish_variant_image_url_sm = "tdti/id/bango/stir-fried/cumi-masak-bumbu(asam-manis,cabe-ijo,dll)-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/us/knorr/pasta/vodka-pasta.png"){
            item.top_dish_variant_image_url_lg = "tdti/us/knorr/pasta/vodka-pasta-(gigi-hadid-pasta).png"
            item.top_dish_variant_image_url_sm = "tdti/us/knorr/pasta/vodka-pasta-(gigi-hadid-pasta)-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/us/knorr/rice/jambalaya.png"){
            item.top_dish_variant_image_url_lg = "tdti/us/knorr/rice/chicken-jambalaya.png"
            item.top_dish_variant_image_url_sm = "tdti/us/knorr/rice/chicken-jambalaya-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/in/hellmanns/salad/potato-salad.png"){
            item.top_dish_variant_image_url_lg = "tdti/in/hellmanns/salad/pasta-salad-1.png"
            item.top_dish_variant_image_url_sm = "tdti/in/hellmanns/salad/pasta-salad-thumb-1.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/id/royco/stir-fried/ikan-masak-bumbu.png"){
            item.top_dish_variant_image_url_lg = "tdti/id/royco/stir-fried/ikan-masak-bumbu(asam-manis,acar-kuning,dst).png"
            item.top_dish_variant_image_url_sm = "tdti/id/royco/stir-fried/ikan-masak-bumbu(asam-manis,acar-kuning,dst)-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/id/royco/other/sambal.png"){
            item.top_dish_variant_image_url_lg = "tdti/id/royco/other/sambal(terasi,mangga,dst).png"
            item.top_dish_variant_image_url_sm = "tdti/id/royco/other/sambal(terasi,mangga,dst)-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/hellmanns/sanduche/burguer.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/hellmanns/sanduiche/burguer.png"
            item.top_dish_variant_image_url_sm = "tdti/br/hellmanns/sanduiche/burguer.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/hellmanns/sanduche/cachorro-quente.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/hellmanns/sanduiche/cachorro-quente.png"
            item.top_dish_variant_image_url_sm = "tdti/br/hellmanns/sanduiche/cachorro-quente.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/hellmanns/sanduche/hambrguer-vegetariano.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/hellmanns/sanduiche/hambúrguer-vegano.png"
            item.top_dish_variant_image_url_sm = "tdti/br/hellmanns/sanduiche/hambúrguer-vegano.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/hellmanns/sanduche/sanduíchede-pastrami.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/hellmanns/sanduiche/sanduíche-de-pastrami.png"
            item.top_dish_variant_image_url_sm = "tdti/br/hellmanns/sanduiche/sanduíche-de-pastrami.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/hellmanns/sanduche/misto-quente.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/hellmanns/sanduiche/misto-quente.png"
            item.top_dish_variant_image_url_sm = "tdti/br/hellmanns/sanduiche/misto-quente.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/hellmanns/sanduche/sanduíche-de-carne.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/hellmanns/sanduiche/sanduíche-de-carne.png"
            item.top_dish_variant_image_url_sm = "tdti/br/hellmanns/sanduiche/sanduíche-de-carne.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/hellmanns/sanduche/hambrguer--de-frango.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/hellmanns/sanduiche/hambúrguer-de-frango.png"
            item.top_dish_variant_image_url_sm = "tdti/br/hellmanns/sanduiche/hambúrguer-de-frango.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/hellmanns/sanduche/sanduíchede-bacon.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/hellmanns/sanduiche/sanduíche-de-bacon.png"
            item.top_dish_variant_image_url_sm = "tdti/br/hellmanns/sanduiche/sanduíche-de-bacon.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/hellmanns/sanduche/sanduíchede-bacon-alface-e-tomate.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/hellmanns/sanduiche/sanduíche-de-bacon,-alface-e-tomate.png"
            item.top_dish_variant_image_url_sm = "tdti/br/hellmanns/sanduiche/sanduíche-de-bacon,-alface-e-tomate.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/hellmanns/sanduche/po-com-ovo.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/hellmanns/sanduiche/pão-com-ovo.png"
            item.top_dish_variant_image_url_sm = "tdti/br/hellmanns/sanduiche/pão-com-ovo.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/hellmanns/sanduche/sanduíchede-frango.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/hellmanns/sanduiche/sanduíche-de-frango.png"
            item.top_dish_variant_image_url_sm = "tdti/br/hellmanns/sanduiche/sanduíche-de-frango.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/hellmanns/sanduche/sanduíchede-mortadela.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/hellmanns/sanduiche/sanduíche-de-mortadela.png"
            item.top_dish_variant_image_url_sm = "tdti/br/hellmanns/sanduiche/sanduíche-de-mortadela.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/hellmanns/sanduche/hambrguer-com-queijo-xis.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/hellmanns/sanduiche/hambúrguer-com-queijo-(xis).png"
            item.top_dish_variant_image_url_sm = "tdti/br/hellmanns/sanduiche/hambúrguer-com-queijo-(xis).png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/hellmanns/sanduche/buraco-quente.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/hellmanns/sanduiche/buraco-quente.png"
            item.top_dish_variant_image_url_sm = "tdti/br/hellmanns/sanduiche/buraco-quente.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/hellmanns/sanduche/sanduíchede-presunto.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/hellmanns/sanduiche/sanduíche-de-presunto.png"
            item.top_dish_variant_image_url_sm = "tdti/br/hellmanns/sanduiche/sanduíche-de-presunto.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/hellmanns/sanduche/sanduíchede-carne-louca.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/hellmanns/sanduiche/sanduíche-de-Carne-louca.png"
            item.top_dish_variant_image_url_sm = "tdti/br/hellmanns/sanduiche/sanduíche-de-Carne-louca.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/hellmanns/sanduche/hambrguer-de-costela.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/hellmanns/sanduiche/hambúrguer-de-costela.png"
            item.top_dish_variant_image_url_sm = "tdti/br/hellmanns/sanduiche/hambúrguer-de-costela.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/hellmanns/sanduche/sanduíche-de-carne-moida.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/hellmanns/sanduiche/sanduíche-de-carne-moida.png"
            item.top_dish_variant_image_url_sm = "tdti/br/hellmanns/sanduiche/sanduíche-de-carne-moida.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/us/knorr/tacos/pork-taco.png"){
            item.top_dish_variant_image_url_lg = "tdti/us/knorr/tacos/pork-tacos.png"
            item.top_dish_variant_image_url_sm = "tdti/us/knorr/tacos/pork-tacos-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/knorr/prato-feito/arroz-feijo-e-salada.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/knorr/prato-feito/arroz,-feijão-e-salada.png"
            item.top_dish_variant_image_url_sm = "tdti/br/knorr/prato-feito/arroz,-feijão-e-salada-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/knorr/prato-feito/arroz-feijo-e-mistura.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/knorr/prato-feito/arroz,-feijão-e-mistura.png"
            item.top_dish_variant_image_url_sm = "tdti/br/knorr/prato-feito/arroz,-feijão-e-mistura-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/knorr/prato-feito/arroz-feijo-e-carne.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/knorr/prato-feito/arroz,-feijão-e-carne.png"
            item.top_dish_variant_image_url_sm = "tdti/br/knorr/prato-feito/arroz,-feijão-e-carne-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/knorr/massa/macarro-bolonhesa.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/knorr/massa/macarrão-bolonhesa.png"
            item.top_dish_variant_image_url_sm = "tdti/br/knorr/massa/macarrão-bolonhesa-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/knorr/carne-e-peixe/carne-moda.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/knorr/carne-e-peixe/carne-moída.png"
            item.top_dish_variant_image_url_sm = "tdti/br/knorr/carne-e-peixe/carne-moída-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/knorr/sopa/sopa-de-feijo.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/knorr/sopa/sopa-de-feijão.png"
            item.top_dish_variant_image_url_sm = "tdti/br/knorr/sopa/sopa-de-feijão-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/knorr/massa/macarro--carbonara.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/knorr/massa/macarrão-à-carbonara.png"
            item.top_dish_variant_image_url_sm = "tdti/br/knorr/massa/macarrão-à-carbonara-thumb.png"
        }
        if(item.top_dish_variant_image_url_lg == "tdti/br/hellmanns/sanduche/sanduche-de-pastrami.png"){
            item.top_dish_variant_image_url_lg = "tdti/br/knorr/massa/macarrão-à-carbonara.png"
            item.top_dish_variant_image_url_sm = "tdti/br/knorr/massa/macarrão-à-carbonara-thumb.png"
        }
        return item
      })
  }